import {defineStore} from "pinia";
import {Category, ProdSpecific} from "../utils/types";
import {ref, Ref} from "vue";

export const useCategoryStore = defineStore("category-store", () => {
    const categories = (window as any).categories as Category[] | undefined;
    const name: Ref<string> = ref((window as any).catName as string);
    const description = (window as any).description as string;
    const years = (window as any).years?.sort((a, b) => +b.name - +a.name ) as Category[] | undefined;
    const altitude = (window as any).altitude as Category[] | undefined;
    const media = (window as any).media as Category[] | undefined;
    const searchPage = (window as any).searchPage as boolean | undefined;
    const specifics = setSpecifics()

    function setName(value: string){
        name.value = value
    }

    function mapSpecific(specific: string): string {
        switch (specific) {
            case ProdSpecific.SUNRISE:
                return 'isSunrise'
            case ProdSpecific.NIGHT_TIME:
                return 'isNighttime'
            case ProdSpecific.PANORAMIC:
                return 'isPanoramic'
            case ProdSpecific.SUNSET:
                return 'isSunset'
            case ProdSpecific.HIGH_ALTITUDE:
                return 'isHighAltitude'
            case ProdSpecific.ARCHIVE:
            default:
                return ''
        }
    }

    function setSpecifics() {
        const items = (window as any).specific as Category[]
        return items?.map(item => {
                return {...item, value: mapSpecific(item.value)}
            }
        ).filter(item => item.value)
    }

    return {
        categories,
        years,
        altitude,
        media,
        description,
        name,
        specifics,
        searchPage,
        setName
    };
});
